export default __webpack_public_path__ + "static/media/3.3b3e46ac.jpg";